import React, { useEffect, useRef, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useGetCategoriesQuery } from '../../../../store/api/categoriesApi'
import { IProductsParams, IProduct } from '../../../../types/products'
import {
  useGetProductsQuery,
  useEditProductMutation,
} from '../../../../store/api/productsApi'
import { ICategory } from '../../../../types/categories'
import Loading from '../../../../assets/icons/loading.svg?react'
import { IProductGroup } from '../../../../types/app'
import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult,
} from 'react-beautiful-dnd'
import { Button } from '@mui/material'
import ProductsModal from './products-modal/ProductsModal'
import AdminMenuItem from '../../components/admin-menu-item/AdminMenuItem'
import './ProductsPage.scss'
import DropComponent from './DropComponent'

const c = 'products-page'

const ProductsPage = () => {
  const [isOpen, setIsOpen] = useState(false)
  const { data: categoriesData = [] } = useGetCategoriesQuery()
  const [categories, setCategories] = useState<ICategory[]>([])
  const [products, setProducts] = useState<IProductGroup[]>([])
  const [searchParams] = useSearchParams()
  const category_id = searchParams.get('category_id')
  const { data: productsData, isLoading: loadingProducts } =
    useGetProductsQuery(category_id ? { category_id } : undefined)
  const [editProduct] = useEditProductMutation()
  const savedScrollRef = useRef(0)

  useEffect(() => {
    if (isOpen) {
      savedScrollRef.current = window.scrollY
    } else {
      const saved = savedScrollRef.current
      if (saved) {
        setTimeout(() => window.scrollTo({ top: saved }), 50)
      }
    }
  }, [isOpen])

  useEffect(() => {
    setCategories(categoriesData)
  }, [categoriesData])

  useEffect(() => {
    if (productsData) {
      setProducts(productsData)
    }
  }, [productsData])

  const onDragEnd = (result: DropResult) => {
    const { source, destination } = result

    // If the item is dropped outside the list
    if (!destination) {
      return
    }

    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    ) {
      return // Item was dropped back in the same position
    }

    const updatedProducts = products.map((product) => {
      if (`category-${product.category_id}` === source.droppableId) {
        const items = Array.from(product.items)

        const [reorderedItem] = items.splice(source.index, 1)

        items.splice(destination.index, 0, reorderedItem)

        // Update the positions for all items
        const updatedItems = items.map((item: IProduct, index) => ({
          ...item,
          position: index,
        }))

        // Assuming editProduct is a function that updates the item in the database
        updatedItems.forEach((item) => {
          editProduct({
            params: { ...item, position: item.position } as unknown as Record<
              string,
              unknown
            >,
            id: item._id,
          })
        })

        return { ...product, items: updatedItems }
      }

      return product
    })

    setProducts(updatedProducts)
  }

  return (
    <div className={c}>
      <div className={`${c}__header`}>
        <div className={`${c}__header-title`}>Produse</div>
        <Button
          variant='contained'
          onClick={() => setIsOpen(true)}
          sx={{
            backgroundColor: 'var(--color-primary)',
            textTransform: 'none',
            fontWeight: 700,
            borderRadius: '8px',
            '&:hover': { backgroundColor: 'var(--color-primary-hover)' },
          }}
        >
          + Adaugă
        </Button>
      </div>

      <div
        className={`${c}__menu-items${
          !products?.[0]?.items.length || loadingProducts ? ' no-data' : ''
        }`}
      >
        {loadingProducts ? (
          <Loading />
        ) : products?.length ? (
          products.map((product: IProductGroup, index) => {
            return (
              <div key={index} className={`${c}__menu-items-container`}>
                {!category_id && (
                  <div className={`${c}__menu-items-container-title`}>
                    {product.category_name}
                  </div>
                )}
                <DragDropContext onDragEnd={onDragEnd}>
                  <DropComponent
                    product={product}
                    setProducts={setProducts}
                    categories={categories}
                  ></DropComponent>
                </DragDropContext>
              </div>
            )
          })
        ) : (
          <div className={`${c}__menu-items-no_data`}>Nu sunt date</div>
        )}
      </div>
      <ProductsModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        categories={categories}
      />
    </div>
  )
}

export default ProductsPage
